import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import INotification from "@/interfaces/notification.interface";
import notificationService from "@/services/notification.service";
import { RequestsProps } from "@/types/requests.types";

export interface IMarkManyAsRead {
  customerId: number;
}

export type MarkManyAsReadProps = {
  formData: IMarkManyAsRead;
} & RequestsProps;

export type Return = {
  markAllAsRead: (props: MarkManyAsReadProps) => Promise<INotification[]>;
} & UseLoadingReturn;

const useMarkManyAsReadNotifications = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IMarkManyAsRead>({
    operation: (formData) => notificationService.markManyAsRead(formData),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, markAllAsRead: create };
};

export default useMarkManyAsReadNotifications;
